const axios = require('axios');
import EventBus from '../api/event-bus.js';
import {errorHandler} from "./common";

export function getHouseByRequest(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/houses/request?requestId=' + id;
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getHouse(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/house?id=' + id;
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateHouse(house) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/house', JSON.stringify(house),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}

export function updateAirHouse(house) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/air/house', JSON.stringify(house),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}

export function getLadingPDF(id) {
  let axiosConfig = {
    method: 'get',
    url: process.env.ROOT_API + 'admin/lading/pdf?id='+id,
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
      "Content-Type": "application/json"
    }
  };
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {
      EventBus.$emit("showLoading", false);
      resolve(response.data);
    }).catch(function(error) {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}

export function createHouse() {
  let item = {
    id:0,
    manifestId:0,
    requestId:0,
    ref:0,
    houseRef:'',
    description:'',
    nop:0,
    destination:'',
    shipperTitle:'',
    shipperAddress1:'',
    shipperTel:'',
    shipperEmail:'',
    consigneeTitle:'',
    consigneeAddress1:'',
    consigneeAddress2:'',
    consigneeAddress3:'',
    consigneeTel:'',
    consigneeEmail:'',
    notifyParty:'',
    notifyPartyAddress:'',
    notifyPartyTel:'',
    notifyPartyEmail:'',

    issuerId: 0,
    issuerTitle:'',
    issuerAddress1:'',
    issuerAddress2:'',
    issuerAddress3:'',
    issuerTel:'',
    issuerEmail:'',
    blNumber:'',
    mblNo:'',
    pointCountryOfOrigin:'',
    obtainer:'',
    vessel:'',
    pod:'',
    pol:'',
    placeOfDelivery:'',
    finalDestination:'',
    signedBy:'',
    signedDate:'',
    dateOfIssue:'',
    onBoardDate:'',
    containerNumber:'',
    containerSize:'',
    sealNumber:'',
    kg:0,
    cbm:0,
    goodsDescription:"C/T BOXES OF USED HOUSEHOLD GOODS & PERSONAL EFFECTS",
    terms:"CFS/CFS",
    accountingInfo:'',
    flight:'',
    carrier:'',
    executedDate:'',
    executedPlace:'LHR',
    handlingInformation: '',

    gw:0,
    gwFloat:0.00,
    cw:0,
    cwFloat:0.00,
    total:0,
    totalFloat:0.00,
    rate:0,
    rateFloat:0.00,
  }
  return item;
}



// WEBPACK FOOTER //
// ./src/api/houses.js